<template>
  <router-link to="/">
    <img alt="logo" class="mt-2 mx-2" src="@/assets/images/logo-30.png"/>
  </router-link>
</template>